'use client';
import { useNavigate, useLocation } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';
import { Globe } from 'react-feather';

const defaultLanguages = ['es', 'en'];

const LanguageSelector = ({ displayedLanguages = defaultLanguages }) => {
	const [isOpen, setIsOpen] = useState(false);
	const dropdownRef = useRef<HTMLDivElement>(null);

	const navigate = useNavigate();
	const location = useLocation();

	const currentLang = location.pathname.split('/')[1];

	const handleLanguageChange = (newLang: string) => {
		const newPathname = location.pathname.replace(`/${currentLang}`, `/${newLang}`);
		navigate(newPathname);
	};

	const toggleDropdown = () => {
		setIsOpen(!isOpen);
	};

	useEffect(() => {
		const handleClickOutside = (event: MouseEvent) => {
			if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
				setIsOpen(false);
			}
		};
		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, []);

	return (
		<div className="relative z-30 cursor-pointer" ref={dropdownRef}>
			<div
				className="flex items-center space-x-2 text-sm align-center p-1"
				onClick={toggleDropdown}
			>
				<Globe size={20} color="#475467" />
				<div className="text-black">{currentLang.toUpperCase()}</div>
			</div>
			{isOpen && (
				<div
					className={`absolute mr-[20px] mt-2 bg-white shadow-md rounded-md w-[170px] cursor-pointer`}
				>
					{displayedLanguages.map((lang) => (
						<div
							key={lang}
							className={`flex items-center px-4 py-2 hover:bg-gray50 rounded-md`}
							onClick={() => handleLanguageChange(lang)}
						>
							<span className="text-black">{lang}</span>
						</div>
					))}
				</div>
			)}
		</div>
	);
};

export default LanguageSelector;
